import React, { useState } from 'react';
import Table from 'components/Table';
import { Breadcrumb } from 'xland-ui';
import { Eye } from 'lucide-react';
import { useCounter } from 'utils/customHooks';
import { formatDate, formatTime } from 'utils/functions';
import { useSelector } from 'react-redux';
import { getCronLogs } from './actions';
import ScriptLogDetails from '../Scripts/scriptLogDetails';

function AdminCrons() {
  const literals = useSelector(state => state.i18n.literals.admin.scripts);
  const literalsCommon = useSelector(state => state.i18n.literals.common);

  const [detailsPopup, setDetailsPopup] = useState(false);
  const tableRefreshFlag = useCounter(0);

  const columns = [
    {
      field: 'name',
      label: literalsCommon.name,
      classes: 'fc-highest border-right',
    },
    {
      field: 'runtime',
      label: literals.runtime,
      preRender: date => formatTime(date, 'seconds', 4),
      width: 120,
      align: 'end',
    },
    {
      field: 'createdAt',
      label: literalsCommon.createdAt,
      preRender: date => formatDate(date, { time: true }),
      width: 130,
      align: 'end',
    },
    {
      field: 'id',
      type: 'menu',
      buttons: [
        {
          icon: Eye,
          text: literalsCommon.view,
          onClick: setDetailsPopup,
        },
      ],
    },
  ];

  return (
    <>
      <Breadcrumb routes={[{ name: 'Logs' }, { name: literals.cronLogs }]} />
      <Table
        columns={columns}
        onClickRow={setDetailsPopup}
        fetch={getCronLogs}
        forceFetch={tableRefreshFlag.value}
      />
      {detailsPopup && (
        <ScriptLogDetails
          literals={literals}
          literalsCommon={literalsCommon}
          script={detailsPopup}
          onClose={() => setDetailsPopup(false)}
        />
      )}
    </>
  );
}

export default AdminCrons;
